var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockTransfer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08203 7.71484L10.4987 10.2732L14.882 7.73151",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.498 14.8073V10.2656",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4659 5.2409L6.79922 6.72423C6.19922 7.05756 5.69922 7.89923 5.69922 8.59089V11.4159C5.69922 12.1076 6.19089 12.9492 6.79922 13.2826L9.4659 14.7659C10.0326 15.0826 10.9659 15.0826 11.5409 14.7659L14.2076 13.2826C14.8076 12.9492 15.3076 12.1076 15.3076 11.4159V8.58257C15.3076 7.8909 14.8159 7.04923 14.2076 6.71589L11.5409 5.23256C10.9659 4.91589 10.0326 4.9159 9.4659 5.2409Z",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 12.5C18.8333 15.725 16.225 18.3333 13 18.3333L13.875 16.875",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 7.5013C2.16602 4.2763 4.77435 1.66797 7.99935 1.66797L7.12436 3.1263",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockTransfer);
export default __webpack_public_path__ + "static/media/stock-transfer.4f7d0f065fc31c6057ded3174b145df1.svg";
export { ForwardRef as ReactComponent };